import React from 'react'
import { Link } from 'react-router-dom'
import "./DrinkWater.css"
import { useTranslation } from 'react-i18next';

function DrinkWater() {
  const { t } = useTranslation();

  return (
    <div className='drinkwater-container'>
      <div className="drinkwater-content">

        <div className='drinkwater-header'>
          <h3>{t('nav_pruduct_drinkwater')}</h3>
        </div>
        <div className='pro-text-promotion'>
          <p>{t('drinkwater-p-one')}</p>


        </div>




        <div className='drinkwater-features'>
          <div className='drinkwater-features-header'>
            <h3>{t('sealing-norm-header-text')}</h3>
          </div>
          <p><strong>{t('sealing-norm-p-one')}</strong>{t('drinkwater-norm-info-one')}</p>
          <p><strong>{t('sealing-norm-p-two')}</strong>{t('drinkwater-norm-info-two')}</p>
          <p><strong>{t('sealing-norm-p-three')}</strong>{t('drinkwater-norm-info-three')}</p>
          <div>
            <strong>- W270</strong>
            <strong>- UBA</strong>
            <strong>- BRL 17504</strong>
            <strong>- KTW</strong>
            <strong>- ACS</strong>
            <strong>- WRAS BS 6920</strong>
            <strong>- NSF/ANSI 61</strong>
          </div>
          <p>{t('drinkwater-norm-detail-text')}</p>


        </div>



        <div className='info-contact'>
          <Link to="/contact" className='btn-contact'>{t('sealing-norm-button')}</Link>
        </div>

      </div>
    </div>
  )
}

export default DrinkWater